<template>
  <list-select
      ref="select"
      async
      :emit-only-value="false"
      v-on:input="(v) => $emit('input', v)"
      :search-data="search"
      :parse-callback="parse"
      v-model="model"
      :autofocus="autofocus"
  />
</template>

<script>
import ListSelect from "@/reuse/input/ListSelect"
import {listQueue as list} from "@/domain/tarefas/services/queue"
export default {
  name: "TaskQueueSelect",
  props: {
    value: {
      required: true
    },
    project: {
      required: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    showPrivates: {
      type: Boolean,
      default: false
    },
    withNoProject: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      model: this.value,
      result: []
    }
  },
  watch: {
    value (v) {
      this.$nextTick(() => {
        if (v !== this.model) {
          this.$refs.select.autoSelectValue(v)
        }
      })
    }
  },
  components: {ListSelect},
  methods: {
    search (terms) {
      console.log('Find', this.model)
      const filtros = []
      if (terms) {
        filtros.push('search=' + terms)
      }
      if (this.project) {
        filtros.push('project=' + this.project)
      }
      if (this.withNoProject) {
        filtros.push('withNoProject=1')
      }
      if (this.showPrivates) {
        filtros.push('showPrivates=1')
      }
      return new Promise((resolve, reject) => {
        list(100, 1, '&' + filtros.join('&'))
            .then(response => {
              this.result = response.data.result
              let list = response.data.result.map((obj) => {
                return {
                  ...obj,
                  value: obj.id,
                  label: obj.name
                }
              }).sort((a, b) => {
                if (a.name > b.name) {
                  return 1;
                }
                if (a.name < b.name) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              })
              resolve(list)
            })
            .catch(({response}) => {
              reject(response)
            })
      })
    },
    parse (v) {
      if (v && v.name) {
        return v.name
      }
      return v
    }
  }
}
</script>
